<template>
  <v-card
    tile
    class="d-inline-block item-card"
    :disabled="!STORE._id"
    :to="{name: `StoreView`, params: { id: STORE._id || 'id', cacheData: STORE }}"
    :ripple="false"
  >
    <v-img
      class="align-center text-center"
      :class="!STORE.logoImage && 'grey lighten-3'"
      :aspect-ratio="1.05"
      :src="STORE.logoImage"
      @error="cantLoadImage=true"
    >
      <v-icon v-if="!STORE.logoImage || cantLoadImage" large color="grey">mdi-image-off-outline</v-icon>
    </v-img>

    <div class="pa-2"><!-- style="min-height: 60px" -->
      <div
        class="font-weight-medium text-truncate text-center primary--text"
        style="letter-spacing: -0.03em"
      >
        {{ STORE.storeName }}
      </div>
      <div v-if="STORE.user" class="caption text-truncate text-center" row>
        {{ STORE.user.name.firstname }} {{ STORE.user.name.lastname }}
      </div>
      <!--???????-->
    </div>
  </v-card>
</template>

<script>
import { storeImageUrl } from "../../services/constants";

export default {
  props: ["store"],
  data() {
    return {
      STORE: {
        storeName: " ",
        logoImage: "",
        user: {
          name: {},
        },
      },
      cantLoadImage: false
    };
  },
  mounted() {
    this.parseStore();
  },
  watch: {
    store() {
      this.parseStore();
    },
  },
  methods: {
    parseStore() {
      if (this.store) {
        this.STORE = { ...this.store };
        if (this.store.logoImage)
          this.STORE.logoImage = storeImageUrl(this.store.logoImage);
      }
    },
  },
};
</script>